// extracted by mini-css-extract-plugin
module.exports = {"divider":"LoginFooter_divider__1Jd0b","social":"LoginFooter_social__dQEZ9","link":"LoginFooter_link__kyjPt"};